export default __webpack_public_path__ + "static/media/firstMonthAssessmentEN.e551995e.png";